import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import './plugins/element.js'
import 'element-ui/lib/theme-chalk/index.css'
import VueTouchKeyboard from 'vue-touch-keyboard'
import VideoPlayer from 'vue-video-player'

import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'

import 'vue-touch-keyboard/dist/vue-touch-keyboard.css' // load default style

// css
import './assets/css/global.css'

// 引入mock数据
import './mock/index'

import './assets/font/iconfont.css'
import axios from 'axios'
import { Message, MessageBox } from 'element-ui'  //引入Message, MessageBox


axios.defaults.baseURL = 'https://api-bld.safe-union.com/wxApp/'
Vue.prototype.$http = axios
Vue.config.productionTip = false
// Vue.use(ElementUi)

Vue.prototype.$message = Message                //vue实例上挂载Message                
Vue.prototype.$messagebox = MessageBox             //vue实例上挂载MessageBox
Vue.use(VueTouchKeyboard)
Vue.use(VideoPlayer)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
